export const flamingo = '#ff4d4f';
export const whitesmoke = '#F5F5F5';
export const bluegrey = '#37474f';
